"use strict";

import React from 'react/addons';

import SimpleChoice from 'ofs/components/simple-choice/SimpleChoice';
import i18n from 'ofs/i18n';

import {currencies, user} from 'ofs/settings';
import {currencySelector as config} from 'ofs/payload';

var gettext = i18n.gettext;

var MESSAGES = {
  LABEL: gettext('Set your currency'),
  DISCLAIMER: gettext('Prices shown are approximate conversions from local currency'),
};


var CurrencySelector = React.createClass({
  handleChange: function() {
    this.getDOMNode().submit();
  },

  render: function() {
    var options = currencies.map((currency) => {
      return <div value={currency['id']} key={currency['id']}>{currency['label']}</div>;
    });

    return (
      <form action={config.url} method="POST" className="ofs-CurrencySelector">
        <div className="ofs-CurrencySelector__InputContainer">
          <label className="ofs-CurrencySelector__Label">{MESSAGES.LABEL}</label>
          <SimpleChoice name="currency" inverse={true}
            className="ofs-SimpleChoice--inline ofs-CurrencySelector__Select"
            defaultValue={user.currencyId} onChange={this.handleChange}>
            {options}
          </SimpleChoice>
        </div>
        <div className="ofs-CurrencySelector__Disclaimer">
          {MESSAGES.DISCLAIMER}
        </div>
      </form>
    );
  }
});

export default CurrencySelector;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/views/CurrencySelector.jsx
 **/